"use client";

import { useMemo } from "react";
import { motion } from "framer-motion";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";
import { staticTechCategories } from "./TechCategories";
import { DecorativeElements } from "../../../componentsGLob/Decorative/decorative-elements";
import { TECH_DECORATIVES } from "./techno-decorative";
import { useTranslation } from "react-i18next";
import { TranslatedTechCategory } from "./interfaces";

export const TechnologiesSection = () => {
  const { t } = useTranslation("techno");

  const translatedTechCategories: TranslatedTechCategory[] = useMemo(() => {
    return staticTechCategories.map((staticItem, index) => ({
      ...staticItem,
      title: t(`categories.${index}.title`),
      description: t(`categories.${index}.description`),
    }));
  }, [t]);

  if (!translatedTechCategories.length) return null;

  return (
    <section className="relative bg-[#000541] py-12 md:py-16" id="tecnologie">
      <div className="absolute inset-0 z-0">
        <DecorativeElements elements={TECH_DECORATIVES} isEnabled={true} />
      </div>

      <ContainerGlob>
        <h2 className="text-4xl font-extrabold text-center mb-4 text-white relative z-10">
          {t("mainTitle")}
        </h2>
        <p className="text-center text-gray-400 mb-12 relative z-10">
          {t("subtitle")}
        </p>

        <div className="relative z-10 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {translatedTechCategories.map((category, i) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="bg-[#1a245f] rounded-2xl p-5 flex items-start gap-4"
            >
              <div
                className={`
                  flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold
                  ${category.color} text-white
                `}
              >
                {i + 1}
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-semibold mb-1 text-white">
                  {category.title}
                </h3>
                <p className="text-sm text-gray-300">
                  {category.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </ContainerGlob>
    </section>
  );
};
